'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'croissant';
var width = 512;
var height = 512;
var aliases = [129360];
var unicode = 'f7f6';
var svgPathData = 'M243.2 .3c4.2-.2 8.5-.3 12.8-.3 62.1 0 118.9 22.1 163.3 58.8L314.6 163.4 243.2 .3zM194 7.6L300.1 249.8c4.4 10.1 2.2 22-5.6 29.8L281 293c-8.2 8.2-20.7 10.2-31.1 5L12 178.3C38.8 94.2 107.7 29 194 7.6zM1.6 226.8l166 83.6-108.9 108.9C22.1 374.9 0 318.1 0 256 0 246.1 .6 236.4 1.6 226.8zM92.7 453.2l120.1-120.1 11.2 5.6 0 135.1c0 19.2-17 34.3-35.5 29.2-35.6-9.7-68.1-26.9-95.7-49.8zM341.2 224l-5.9-13.4 117.9-117.9c22.9 27.6 40.1 60.1 49.8 95.7 5.1 18.6-10 35.5-29.2 35.5l-132.6 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCroissant = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;